(function () {
  angular.module('binky.core.api.search', ['binky.core.lodash', 'ngResource']);
})();
